import React from 'react';
import { Link, Text } from '@Sage/hoi-poi-ui';
import { canViewEntity } from 'utils/entityPermissions';

const EntityLink = ({ entity, href, onClick, children, linkProps = {}, textProps = {} }) => {
    if (!canViewEntity(entity)) {
        return <Text {...textProps}>{children}</Text>;
    }

    return (
        <Link href={href} onClick={onClick} {...linkProps}>
            {children}
        </Link>
    );
};

export default EntityLink;
